import { ConfirmDialog } from 'primereact/confirmdialog';
import { ReactNode } from 'react';

type Props = {
    children?: ReactNode;
    tituloPagina: string;
};

const DefaultBase = (props: Props) => {

    return (
        <div>
            {props.children}
        </div>
    );
};

function Base(props: Props) {

    return (
        <DefaultBase tituloPagina={props.tituloPagina}>
            <ConfirmDialog />
            {props.children}
        </DefaultBase>
    );
}

Base.defaultProps = {
};

export default Base;
